import React, { useMemo } from "react"
import { baseUrlImg } from "../../config/api"

function formatDate(dateString) {
  if (!dateString) return "-"
  const date = new Date(dateString)
  return date.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })
}

const AmilonTicket = ({ arr }) => {
  const receiptData = useMemo(() => {
    try {
      return arr.receipt ? JSON.parse(arr.receipt) : {}
    } catch {
      return {}
    }
  }, [arr.receipt])

  return (
    <div>
      <div className="json_spedizionepro">
        <div
          className="d-flex justify-content-center mb-4"
          style={{ border: "unset" }}
        >
          <img src={`${baseUrlImg}/${arr.logo}`} alt="service logo" height={50} />
        </div>

        <div style={{ paddingTop: 10 }}>
          Data inizio validità:{" "}
          <span>{formatDate(receiptData.ValidityStartDate)}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Data fine validità: <span>{formatDate(receiptData.ValidityEndDate)}</span>
        </div>

        <div style={{ paddingTop: 10 }}>
          Card Code: <span>{receiptData.CardCode || "-"}</span>
        </div>

        {receiptData.Pin && (
          <div style={{ paddingTop: 10 }}>
            PIN: <span>{receiptData.Pin}</span>
          </div>
        )}

        {receiptData.RetailerName && (
          <div style={{ paddingTop: 10 }}>
            Retailer: <span>{receiptData.RetailerName}</span>
          </div>
        )}

        {receiptData.Amount !== undefined && (
          <div style={{ paddingTop: 10 }}>
            Amount: <span>{receiptData.Amount} €</span>
          </div>
        )}
      </div>

      {receiptData.VoucherLink && (
        <div style={{ width: "100%", wordBreak: "break-word" }}>
          <div style={{ marginBottom: "5px", marginTop: "10px", fontWeight: "400" }}>
            Per l'attivazione della gift card clicca il link qui sotto:
          </div>
          <a
            href={receiptData.VoucherLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#3b82f6",
              textDecoration: "underline",
              display: "inline-block",
            }}
          >
            {receiptData.VoucherLink}
          </a>
        </div>
      )}
    </div>
  )
}

export default AmilonTicket
